<template>
  <div class="animated fadeIn report main-div">
    <vLoading v-if="vLoading" />
    <div class="pe-6 ps-6 py-10">
      <v-row dir="ltr" class="pb-2">
        <v-col class="text-sm-left text-center">
          <v-btn
            to="/admin/advancedReport"
            class="bc-primary text-white no-underline"
            elevation="0"
            width="230"
            ><span class="c-light">بازگشت به صفحه اصلی</span></v-btn
          >
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center fs-xlarge c-dark pt-sm-0 pt-6"
          ><span>گزارش دانشگاه</span></v-col
        >
      </v-row>
      <hr class="my-4" />
      <div class="d-lg-block d-none">
        <v-stepper v-model="stepNumber" alt-labels>
          <v-stepper-header>
            <v-stepper-step
              :complete="stepNumber > 1"
              :active-icon="'mdi-pen'"
              step="1"
            >
              <div @click="stepNumber = 1" class="text-center pointer">
                <p class="fs-xsmall mb-3">گام اول</p>
                <p class="mb-0">انتخاب استان</p>
                <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
                  (
                  <span v-if="selectedStates.length">
                    {{ selectedStates.length + " استان" }}
                  </span>
                  <br
                    v-if="
                      selectedStates.length && (noUniversity || otherUniversity)
                    "
                  />
                  <p
                    v-if="
                      selectedStates.length && (noUniversity || otherUniversity)
                    "
                    class="my-0 grey--text"
                  >
                    +
                  </p>
                  <span v-if="noUniversity">بدون استان</span>
                  <br v-if="noUniversity && otherUniversity" />
                  <p
                    v-if="noUniversity && otherUniversity"
                    class="my-0 grey--text"
                  >
                    +
                  </p>
                  <span v-if="otherUniversity">سایر استان‌ها</span>
                  )
                </div>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 1 ? 'completed' : ''"></v-divider>

            <v-stepper-step :complete="stepNumber > 2" step="2">
              <div
                @click="
                  stepNumber > 1 && selectedStates.length
                    ? (stepNumber = 2)
                    : ''
                "
                :class="
                  stepNumber > 1 && selectedStates.length ? 'pointer' : ''
                "
                class="text-center"
              >
                <p class="fs-xsmall mb-3">گام دوم</p>
                <p class="mb-0">انتخاب دانشگاه</p>
                <div v-if="stepNumber > 2" class="c-grey mb-0 mt-3">
                  (
                  <span v-if="selectedUniversity.length">
                    {{ selectedUniversity.length + " دانشگاه" }}
                  </span>
                  <br
                    v-if="
                      selectedUniversity.length &&
                      (noUniversity || otherUniversity)
                    "
                  />
                  <p
                    v-if="
                      selectedUniversity.length &&
                      (noUniversity || otherUniversity)
                    "
                    class="my-0 grey--text"
                  >
                    +
                  </p>
                  <span v-if="noUniversity">بدون دانشگاه</span>
                  <br v-if="noUniversity && otherUniversity" />
                  <p
                    v-if="noUniversity && otherUniversity"
                    class="my-0 grey--text"
                  >
                    +
                  </p>
                  <span v-if="otherUniversity">سایر دانشگاه‌ها</span>
                  )
                </div>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 2 ? 'completed' : ''"></v-divider>

            <v-stepper-step :complete="stepNumber > 3" step="3">
              <div
                @click="stepNumber > 2 ? (stepNumber = 3) : ''"
                :class="stepNumber > 2 ? 'pointer' : ''"
                class="text-center"
              >
                <p class="fs-xsmall mb-3">گام سوم</p>
                <p class="mb-0">انتخاب زمان</p>
                <div v-if="stepNumber > 3" class="c-grey mb-0 mt-3">
                  <span v-if="timeType == 'all'">(گزارش تجمیعی)</span>
                  <span v-if="timeType == 'year'"
                    >(گزارش سال {{ selectedYear }})</span
                  >
                  <div v-if="timeType == 'time'">
                    ( گزارش از تاریخ
                    {{
                      selectedRange.fromYear +
                      "/" +
                      selectedRange.fromMonth +
                      "/" +
                      selectedRange.fromDay
                    }}
                    تا
                    {{
                      selectedRange.toYear +
                      "/" +
                      selectedRange.toMonth +
                      "/" +
                      selectedRange.toDay
                    }})
                  </div>
                </div>
              </div>
            </v-stepper-step>

            <v-divider :class="stepNumber > 3 ? 'completed' : ''"></v-divider>

            <v-stepper-step step="4">
              <div class="text-center">
                <p class="fs-xsmall mb-3">گام چهارم</p>
                <p class="mb-0">مشاهده و خروجی</p>
              </div>
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </div>
      <div class="d-lg-none d-sm-block d-none pt-4">
        <div class="d-flex flex-row justify-content-center c-grey">
          <div
            class="text-center pointer"
            @click="stepNumber = 1"
            :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
          >
            <span>انتخاب استان</span>
            <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedStates.length">
                {{ selectedStates.length + " استان" }}
              </span>
              <br
                v-if="
                  selectedStates.length && (noUniversity || otherUniversity)
                "
              />
              <p
                v-if="
                  selectedStates.length && (noUniversity || otherUniversity)
                "
                class="my-0 grey--text"
              >
                +
              </p>
              <span v-if="noUniversity">بدون استان</span>
              <br v-if="noUniversity && otherUniversity" />
              <p v-if="noUniversity && otherUniversity" class="my-0 grey--text">
                +
              </p>
              <span v-if="otherUniversity">سایر استان‌ها</span>
              )
            </div>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div
            class="text-center"
            @click="
              stepNumber > 1 && selectedStates.length ? (stepNumber = 2) : ''
            "
            :class="stepNumber > 1 && selectedStates.length ? 'pointer' : ''"
          >
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 2 ? 'c-primary' : ''
              "
              >انتخاب دانشگاه</span
            >
            <div v-if="stepNumber > 2" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedUniversity.length">
                {{ selectedUniversity.length + " دانشگاه" }}
              </span>
              <br
                v-if="
                  selectedUniversity.length && (noUniversity || otherUniversity)
                "
              />
              <p
                v-if="
                  selectedUniversity.length && (noUniversity || otherUniversity)
                "
                class="my-0 grey--text"
              >
                +
              </p>
              <span v-if="noUniversity">بدون دانشگاه</span>
              <br v-if="noUniversity && otherUniversity" />
              <p v-if="noUniversity && otherUniversity" class="my-0 grey--text">
                +
              </p>
              <span v-if="otherUniversity">سایر دانشگاه‌ها</span>
              )
            </div>
          </div>

          <div>
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div
            class="text-center"
            @click="stepNumber > 2 ? (stepNumber = 3) : ''"
            :class="stepNumber > 3 ? 'pointer' : ''"
          >
            <span
              :class="
                stepNumber == 3 ? 'c-pink' : stepNumber > 3 ? 'c-primary' : ''
              "
              >انتخاب زمان</span
            >
            <div v-if="stepNumber > 3" class="c-grey mb-0 mt-3">
              <span v-if="timeType == 'all'">(گزارش تجمیعی)</span>
              <span v-if="timeType == 'year'"
                >(گزارش سال {{ selectedYear }})</span
              >
              <div v-if="timeType == 'time'">
                <p class="mb-1">
                  ( گزارش از
                  {{
                    selectedRange.fromYear +
                    "/" +
                    selectedRange.fromMonth +
                    "/" +
                    selectedRange.fromDay
                  }}
                </p>
                <p>
                  تا
                  {{
                    selectedRange.toYear +
                    "/" +
                    selectedRange.toMonth +
                    "/" +
                    selectedRange.toDay
                  }}
                  )
                </p>
              </div>
            </div>
          </div>
          <div>
            <v-icon class="mx-5">mdi-chevron-left</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 4 ? 'c-pink' : stepNumber > 4 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <div class="d-block d-sm-none text-center py-4">
        <div class="d-flex flex-column justify-content-center c-grey">
          <div class="text-center" @click="stepNumber = 1">
            <span :class="stepNumber == 1 ? 'c-pink' : 'c-primary'"
              >انتخاب استان</span
            >
            <div v-if="stepNumber > 1" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedStates.length">
                {{ selectedStates.length + " استان" }}
              </span>
              <br
                v-if="
                  selectedStates.length && (noUniversity || otherUniversity)
                "
              />
              <p
                v-if="
                  selectedStates.length && (noUniversity || otherUniversity)
                "
                class="my-0 grey--text"
              >
                +
              </p>
              <span v-if="noUniversity">بدون استان</span>
              <br v-if="noUniversity && otherUniversity" />
              <p v-if="noUniversity && otherUniversity" class="my-0 grey--text">
                +
              </p>
              <span v-if="otherUniversity">سایر استان‌ها</span>
              )
            </div>
          </div>
          <div class="text-center">
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div
            class="text-center"
            @click="
              stepNumber > 1 && selectedStates.length ? (stepNumber = 2) : ''
            "
          >
            <span
              :class="
                stepNumber == 2 ? 'c-pink' : stepNumber > 2 ? 'c-primary' : ''
              "
              >انتخاب دانشگاه</span
            >
            <div v-if="stepNumber > 2" class="c-grey mb-0 mt-3">
              (
              <span v-if="selectedUniversity.length">
                {{ selectedUniversity.length + " دانشگاه" }}
              </span>
              <br
                v-if="
                  selectedUniversity.length && (noUniversity || otherUniversity)
                "
              />
              <p
                v-if="
                  selectedUniversity.length && (noUniversity || otherUniversity)
                "
                class="my-0 grey--text"
              >
                +
              </p>
              <span v-if="noUniversity">بدون دانشگاه</span>
              <br v-if="noUniversity && otherUniversity" />
              <p v-if="noUniversity && otherUniversity" class="my-0 grey--text">
                +
              </p>
              <span v-if="otherUniversity">سایر دانشگاه‌ها</span>
              )
            </div>
          </div>

          <div>
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div
            class="text-center"
            @click="stepNumber > 2 ? (stepNumber = 3) : ''"
          >
            <span
              @click="stepNumber > 2 ? (stepNumber = 3) : ''"
              :class="
                stepNumber == 3 ? 'c-pink' : stepNumber > 3 ? 'c-primary' : ''
              "
              >انتخاب زمان</span
            >
            <div v-if="stepNumber > 3" class="c-grey my-2">
              <span v-if="timeType == 'all'">(گزارش تجمیعی)</span>
              <span v-if="timeType == 'year'"
                >(گزارش سال {{ selectedYear }})</span
              >
              <div v-if="timeType == 'time'">
                <p class="mb-1">
                  ( گزارش از
                  {{
                    selectedRange.fromYear +
                    "/" +
                    selectedRange.fromMonth +
                    "/" +
                    selectedRange.fromDay
                  }}
                </p>
                <p>
                  تا
                  {{
                    selectedRange.toYear +
                    "/" +
                    selectedRange.toMonth +
                    "/" +
                    selectedRange.toDay
                  }}
                  )
                </p>
              </div>
            </div>
          </div>
          <div>
            <v-icon class="mx-5">mdi-chevron-down</v-icon>
          </div>
          <div>
            <span
              :class="
                stepNumber == 4 ? 'c-pink' : stepNumber > 4 ? 'c-primary' : ''
              "
              >مشاهده و خروجی</span
            >
          </div>
        </div>
      </div>
      <hr class="my-4" />
      <!-- Step 1 -->
      <div v-if="stepNumber == 1">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row>
            <v-col class="pt-6 text-sm-right text-center">
              <span class="c-dark fs-large"
                >استان مورد نظر خود را انتخاب کنید.</span
              >
            </v-col>
            <v-col sm="6" cols="12">
              <v-text-field
                rounded
                filled
                clearable
                class="search-box mt-2 mt-sm-0"
                placeholder="نام استان را جستجو کنید..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3 pe-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <div v-if="!this.filter" class="mt-1 mb-5">
            <v-btn
              @click="!total ? selectAll('state') : removeAll('state')"
              elevation="0"
              class="all-btn"
              >{{ !total ? "همه" : "هیچ" }}</v-btn
            >
          </div>
          <div class="reportCheckBox pt-1 pb-4">
            <v-switch
              v-model="noUniversity"
              label="حمایت‌های فاقد استان/دانشگاه را نشان بده"
              color="#068d9d"
            ></v-switch>
            <v-switch
              v-model="otherUniversity"
              label="حمایت‌های سایر استان‌ها/دانشگاه‌ها را نشان بده"
              color="#068d9d"
              @change="selectOther()"
            ></v-switch>
          </div>

          <div v-if="!computedStates.length" class="text-center c-grey">
            <hr />
            موردی یافت نشد.
            <hr />
          </div>

          <v-row>
            <v-col
              lg="3"
              md="3"
              sm="4"
              cols="12"
              v-for="(item, index) in computedStates"
              :key="index"
            >
              <div
                class="item-box"
                @click="chooseState(item)"
                :class="
                  selectedStates.includes(item.name) ? 'selected-box' : ''
                "
              >
                {{ item.name }}
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Step 2 -->
      <div v-if="stepNumber == 2">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <div class="d-sm-inline-block d-none py-4">
            <span class="pt-4 pe-6 c-grey">استان‌ها:</span>
            <div
              v-for="(item, index) in selectedStates"
              :key="index"
              class="selectedState-box"
            >
              {{ item }}
              <span @click="clearItem(index)" class="pointer">
                <v-icon class="red--text pt-3 ps-3 pe-0">mdi-close</v-icon>
              </span>
            </div>
          </div>
          <v-row>
            <v-col class="pt-6 text-sm-right text-center">
              <span class="c-dark fs-large"
                >دانشگاه مورد نظر خود را انتخاب کنید.</span
              >
            </v-col>
            <v-col sm="4" cols="12">
              <v-text-field
                rounded
                filled
                append-icon="mdi-close"
                @click:append="filter = ''"
                class="search-box mt-2 mt-sm-0"
                placeholder="نام دانشگاه را جستجو کنید..."
                v-model="filter"
                @input="goFirst()"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3 pe-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>

          <div
            v-if="!this.filter && computedUniversities.length"
            class="mt-1 mb-5"
          >
            <v-btn
              @click="!total2 ? selectAll('uni') : removeAll('uni')"
              elevation="0"
              class="all-btn"
              >{{ !total2 ? "همه" : "هیچ" }}</v-btn
            >
          </div>

          <div class="universities-page">
            <div v-if="!computedUniversities.length" class="text-center c-grey">
              <hr />
              موردی یافت نشد.
              <hr />
            </div>
            <v-row>
              <v-col
                lg="3"
                md="3"
                sm="4"
                cols="12"
                v-for="(item, index) in computedUniversities"
                :key="index"
              >
                <div
                  @click="chooseUniversity(item)"
                  class="item-box d-flex flex-column py-4"
                  :class="
                    selectedUniversity.includes(item.id) ? 'selected-box' : ''
                  "
                >
                  <div
                    class="check-box"
                    :class="
                      selectedUniversity.includes(item.id) ? 'b-primary' : ''
                    "
                  >
                    <v-icon
                      v-if="selectedUniversity.includes(item.id)"
                      class="c-primary"
                      >mdi-circle</v-icon
                    >
                  </div>

                  <img
                    class="uni-logo"
                    :src="item.url ? item.url : '/uniLogo.png'"
                    alt=""
                  />
                  <span class="text-center pt-3">{{ item.name }}</span>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="universitiesTotalRows" class="mt-6">
            <v-col>
              <v-pagination
                v-model="universitiesCurrentPage"
                :length="
                  Math.ceil(
                    university.filter((x) => x.name.includes(filter)).length /
                      universitiesPerPage
                  )
                "
                :total-visible="5"
                prev-icon="arrow_back"
                next-icon="arrow_forward"
                class="float-end"
              ></v-pagination>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- Step 3 -->
      <div v-if="stepNumber == 3">
        <v-row>
          <v-col class="pt-6 text-sm-right text-center">
            <span class="c-dark fs-large"
              >زمان مورد نظر برای گرفتن گزارشات را انتخاب کنید .</span
            >
          </v-col>
        </v-row>
        <v-row class="py-8">
          <v-col md="4" sm="12" cols="12">
            <div
              @click="timeType = 'all'"
              :class="timeType == 'all' ? 'selected-box2' : ''"
              class="common-card h-100 pb-9 b-primary-bold pointer"
            >
              <div class="text-center my-10">
                <p class="fs-xlarge c-primary font-weight-bold">تجمیعی</p>
                <p class="fs-large c-grey mb-0 mt-14">
                  با انتخاب این گزینه شما قادر به دریافت گزارش تجمیعی هستید.
                </p>
              </div>
            </div>
          </v-col>
          <v-col md="4" sm="12" cols="12">
            <div
              @click="timeType != 'year' ? (showYearModal = true) : ''"
              :class="timeType == 'year' ? 'selected-box2' : 'pointer'"
              class="common-card h-100 pb-9 b-primary-bold"
            >
              <div class="text-center mt-10">
                <p class="fs-xlarge c-primary font-weight-bold">تفکیک سال</p>
                <p
                  v-if="timeType != 'year'"
                  class="fs-large c-grey mb-0 mt-14 m-10"
                >
                  پس از انتخاب این گزینه و مشخص کردن سال مورد نظر به گام بعدی
                  بروید.
                </p>
                <div v-else class="pt-5">
                  <p class="fs-large mb-10">گزارش سال {{ selectedYear }}</p>
                  <v-btn
                    @click="showYearModal = true"
                    elevation="0"
                    class="btn-radius bc-white c-primary w-100"
                    height="44"
                    ><span class="fs-medium font-weight-bold"
                      >تغییر سال</span
                    ></v-btn
                  >
                </div>
              </div>
            </div>
            <year-modal
              v-if="showYearModal"
              :chosenYear="year"
              @dialogYear="getItemYear"
              @showModal="getShowModal"
            ></year-modal>
          </v-col>
          <v-col md="4" sm="12" cols="12">
            <div
              @click="timeType != 'time' ? goToSelectRange() : ''"
              :class="timeType == 'time' ? 'selected-box2' : 'pointer'"
              class="common-card h-100 pb-9 b-primary-bold"
            >
              <div class="text-center mt-10">
                <p class="fs-xlarge c-primary font-weight-bold">
                  بازه زمانی دلخواه
                </p>
                <p v-if="timeType != 'time'" class="fs-large c-grey mb-0 mt-14">
                  پس از انتخاب این گزینه و مشخص کردن بازه زمانی مورد نظر به گام
                  بعدی بروید.
                </p>
                <div v-else class="pt-5">
                  <p class="fs-large mb-10">
                    گزارش از تاریخ
                    {{
                      selectedRange.fromYear +
                      "/" +
                      selectedRange.fromMonth +
                      "/" +
                      selectedRange.fromDay
                    }}
                    تا
                    {{
                      selectedRange.toYear +
                      "/" +
                      selectedRange.toMonth +
                      "/" +
                      selectedRange.toDay
                    }}
                  </p>
                  <v-btn
                    @click="selectTimeRangeDialog = true"
                    elevation="0"
                    class="btn-radius bc-white c-primary w-100"
                    height="44"
                    ><span class="fs-medium font-weight-bold"
                      >تغییر بازه زمانی</span
                    ></v-btn
                  >
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-dialog v-model="selectTimeRangeDialog" width="800">
          <v-card
            class="modal-card"
            style="max-height: 500px; overflow-y: auto"
          >
            <v-container class="pa-5">
              <v-row class="mb-1">
                <v-col class="text-right">
                  <span class="fs-large c-dark pt-1"
                    >بازه زمانی مورد نظر را انتخاب کنید:</span
                  >
                </v-col>
                <v-col cols="2" class="text-left">
                  <span @click="selectTimeRangeDialog = false">
                    <v-icon class="pointer">$Close</v-icon>
                  </span>
                </v-col>
              </v-row>
              <div class="py-4">
                <div class="d-flex flex-sm-row flex-column">
                  <span class="fs-large c-dark pt-3 pb-sm-0 pb-4"
                    >از تاریخ:</span
                  >
                  <v-row class="ps-4 pe-0">
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          سال
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ range.fromYear }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                          class="edit-icon pointer"
                          @click="showYearFromModal = true"
                        >
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                        <year-modal
                          v-if="showYearFromModal"
                          :chosenYear="range.fromYear"
                          @dialogYear="getYearFrom"
                          @showModal="getYearFromModal"
                        ></year-modal>
                      </div>
                    </v-col>
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          ماه
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ persianMonthName(range.fromMonth) }}
                        </div>
                        <v-spacer></v-spacer>
                        <div class="edit-icon pointer" id="datePicker2">
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                      </div>
                    </v-col>
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          روز
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ range.fromDay }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                          @click="
                            dateType = 'from';
                            selectDayModal = true;
                          "
                          class="edit-icon pointer"
                        >
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
                <div class="d-flex flex-sm-row flex-column mt-8">
                  <span class="fs-large c-dark pt-3 pb-sm-0 pb-4"
                    >تا تاریخ:</span
                  >
                  <v-row class="ps-4 pe-0">
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          سال
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ range.toYear }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                          class="edit-icon pointer"
                          @click="showYearToModal = true"
                        >
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                        <year-modal
                          v-if="showYearToModal"
                          :chosenYear="range.toYear"
                          @dialogYear="getYearTo"
                          @showModal="getYearToModal"
                        ></year-modal>
                      </div>
                    </v-col>
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          ماه
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ persianMonthName(range.toMonth) }}
                        </div>
                        <v-spacer></v-spacer>
                        <div class="edit-icon pointer" id="datePicker4">
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                      </div>
                    </v-col>
                    <v-col>
                      <div
                        class="b-primary main-radius pe-4 ps-4 py-3 d-flex flex-row"
                      >
                        <div class="ps-4 pe-4 fit-content c-primary fs-large">
                          روز
                        </div>
                        <div class="c-grey fs-medium" style="padding-top: 1px">
                          {{ range.toDay }}
                        </div>
                        <v-spacer></v-spacer>
                        <div
                          @click="
                            dateType = 'to';
                            selectDayModal = true;
                          "
                          class="edit-icon pointer"
                        >
                          <v-icon class="c-primary">$Edit</v-icon>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </div>
              <date-picker
                element="datePicker2"
                v-model="range.fromMonth"
                @change="
                  getNumberOfDays('from');
                  changeDate('month');
                "
                type="month"
                :auto-submit="true"
              >
              </date-picker>
              <date-picker
                element="datePicker4"
                v-model="range.toMonth"
                @change="getNumberOfDays('to')"
                type="month"
                :auto-submit="true"
                :min="range.fromYear == range.toYear ? range.fromMonth : ''"
              >
              </date-picker>
              <div class="pt-4 text-right">
                <v-btn
                  class="bc-primary btn-radius c-light"
                  width="100"
                  height="47"
                  @click="
                    selectedRange = JSON.parse(JSON.stringify(range));
                    selectTimeRangeDialog = false;
                    timeType = 'time';
                  "
                  >تایید</v-btn
                >
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog v-model="selectDayModal" width="300">
          <v-card class="modal-card pa-0">
            <div v-if="dateType == 'from'">
              <v-card-title class="bc-primary py-4">
                <span
                  class="mx-auto c-light text-center"
                  style="font-size: 2rem"
                  >{{ range.fromDay }}</span
                >
              </v-card-title>
              <div class="fit-content pa-5">
                <div
                  v-for="(number, index) in fromNumberOfDay"
                  :key="index"
                  class="day-box d-inline-block pointer"
                  :class="parseInt(range.fromDay) == number ? 'selected' : ''"
                  @click="
                    selectDayModal = false;
                    range.fromDay = number;
                  "
                >
                  {{ number }}
                </div>
              </div>
            </div>
            <div v-else>
              <v-card-title class="bc-primary py-4">
                <span
                  class="mx-auto c-light text-center"
                  style="font-size: 2rem"
                  >{{ range.toDay }}</span
                >
              </v-card-title>
              <div class="fit-content pa-5">
                <div
                  v-for="(number, index) in toNumberOfDay"
                  :key="index"
                  class="day-box d-inline-block"
                  :class="parseInt(range.toDay) == number ? 'selected' : ''"
                >
                  <div
                    v-if="
                      range.fromYear == range.toYear &&
                      range.fromMonth == range.toMonth
                    "
                  >
                    <div
                      class="pointer"
                      @click="
                        selectDayModal = false;
                        range.toDay = number;
                      "
                      v-if="index >= parseInt(range.fromDay) - 1"
                    >
                      {{ number }}
                    </div>
                    <div v-else class="disabled">
                      {{ number }}
                    </div>
                  </div>
                  <div
                    class="pointer"
                    @click="
                      selectDayModal = false;
                      range.toDay = number;
                    "
                    v-else
                  >
                    {{ number }}
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </v-dialog>
      </div>

      <!-- Step 4 -->
      <div v-if="stepNumber == 4" class="pb-6">
        <div v-if="pageLoading" class="text-center py-16 my-16">
          <fold></fold>
          <p class="c-dark">در حال بارگذاری...</p>
        </div>
        <div v-else>
          <v-row>
            <v-col
              v-if="selectedUniversity.length"
              class="pt-6 text-sm-right text-center"
            >
              <v-btn @click="selectedUniDialog = true" class="secondary-btn">
                <span class="fs-medium">
                  {{ selectedUniversity.length }} دانشگاه</span
                >
              </v-btn>
            </v-col>
            <v-spacer class="d-none d-sm-block"></v-spacer>
            <v-col cols="" class="pt-6 text-sm-left text-center">
              <v-btn
                class="bc-primary text-white btn-radius"
                width="200"
                height="47"
                elevation="0"
                @click="saveDocx('doc')"
              >
                <span class="fs-small">
                  خروجی ورد

                  <v-icon>$Word</v-icon></span
                >
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-tabs v-model="tab">
                <v-tab class="c-primary" v-if="deviceType == 'desktop'"
                  >نمودار‌ها</v-tab
                >
                <v-tab class="c-primary">جدول‌ها</v-tab>
              </v-tabs>
              <hr class="hr-mt" />
              <v-tabs-items v-model="tab">
                <!-- نمودار‌ها -->

                <v-tab-item v-if="deviceType == 'desktop'">
                  <v-container class="pe-10 ps-10 pt-12">
                    <div class="text-center" v-if="computedCharts">
                      <hr />
                      موردی برای نمایش وجود ندارد.
                      <hr />
                    </div>
                    <div
                      v-if="allData.barChartHasData"
                      id="capture1"
                      class="pa-6"
                    >
                      <v-row>
                        <v-col md="6" sm="6" cols="12"
                          ><h5 class="fs-xlarge">
                            نمودار فراوانی حمایت‌ها به تفکیک نوع حمایت
                          </h5></v-col
                        >
                        <v-spacer></v-spacer>
                        <v-col class="text-left" md="6" sm="6" cols="12">
                          <span v-show="false">{{ reactivity }}</span>
                          <v-btn
                            class="bc-primary text-white btn-radius"
                            width="200"
                            height="47"
                            elevation="0"
                            @click="
                              capture(
                                'capture1',
                                'نمودار-فراوانی-حمایت‌ها-به-تفکیک-نوع-حمایت',
                                0
                              )
                            "
                            :loading="gettingPic[0]"
                            data-html2canvas-ignore
                          >
                            <template v-slot:loader>
                              <span
                                class="white--text fs-xsmall d-flex flex-row"
                              >
                                <span
                                  ><v-icon class="white--text"
                                    >mdi-timer-sand-empty</v-icon
                                  >
                                  چند لحظه صبر کنید...
                                </span>
                              </span>
                            </template>
                            <span class="fs-small">
                              خروجی عکس

                              <v-icon>$Camera</v-icon></span
                            >
                          </v-btn>
                          <a id="download"></a>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col v-if="barBusy" class="text-center">
                          <v-progress-circular
                            indeterminate
                            color="#068D9D"
                            class="align-middle button-td"
                          ></v-progress-circular>
                        </v-col>
                        <v-col v-else>
                          <Chart
                            name="barChart"
                            :chartdata="dataBar"
                            :options="optionsBar1"
                            type="bar"
                            :height="deviceType != 'mobile' ? '200' : '400'"
                            v-if="barLoaded"
                          ></Chart>
                        </v-col>
                      </v-row>
                    </div>
                    <div class="mt-16">
                      <div
                        v-if="allData.pieChartHasData"
                        id="capture2"
                        class="pa-6"
                      >
                        <v-row>
                          <v-col md="6" sm="6" cols="12"
                            ><h5 class="fs-xlarge">
                              نمودار تقسیم بندی نسبی حمایت‌های انجام شده
                            </h5></v-col
                          >
                          <v-spacer></v-spacer>
                          <v-col class="text-left" md="6" sm="6" cols="12">
                            <v-btn
                              class="bc-primary text-white btn-radius"
                              width="200"
                              height="47"
                              elevation="0"
                              @click="
                                capture(
                                  'capture2',
                                  'نمودار-تقسیم‌بندی-نسبی-حمایت‌های-انجام-شده',
                                  1
                                )
                              "
                              :loading="gettingPic[1]"
                              data-html2canvas-ignore
                            >
                              <template v-slot:loader>
                                <span
                                  class="white--text fs-xsmall d-flex flex-row"
                                >
                                  <span
                                    ><v-icon class="white--text"
                                      >mdi-timer-sand-empty</v-icon
                                    >
                                    چند لحظه صبر کنید...
                                  </span>
                                </span>
                              </template>
                              <span class="fs-small">
                                خروجی عکس

                                <v-icon>$Camera</v-icon></span
                              >
                            </v-btn>
                            <a id="download"></a>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col v-if="doughnutBusy" class="text-center">
                            <v-progress-circular
                              indeterminate
                              color="#068D9D"
                              class="align-middle button-td"
                            ></v-progress-circular>
                          </v-col>
                          <v-col v-else>
                            <v-row>
                              <v-col lg="5" cols="12" class="ps-lg-0">
                                <Chart
                                  name="pieChart"
                                  :chartdata="dataPie"
                                  :options="optionsBar2"
                                  type="doughnut"
                                  v-if="doughnutLoaded"
                                ></Chart>
                              </v-col>
                              <v-col>
                                <v-row class="mt-lg-12">
                                  <v-col
                                    md="6"
                                    cols="12"
                                    class="pe-9 ps-9"
                                    v-for="(item, index) in dataPie.labels"
                                    :key="index"
                                  >
                                    <v-row class="c-grey mb-lg-3">
                                      <v-col cols="2">
                                        <v-icon
                                          :color="
                                            dataPie.datasets[0].backgroundColor[
                                              index
                                            ]
                                          "
                                          large
                                          >mdi-circle</v-icon
                                        >
                                      </v-col>
                                      <v-col class="pt-5 pe-5 ps-5">
                                        {{ dataPie.labels[index] }}
                                      </v-col>
                                      <v-col class="pt-5" cols="2">
                                        {{
                                          dataPie.datasets[0].data[index] + "%"
                                        }}
                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-container>
                </v-tab-item>

                <!-- جدول‌ها -->
                <v-tab-item>
                  <div class="main-table">
                    <div v-if="deviceType == 'mobile'">
                      <h4 class="mt-6 text-sm-right text-center">
                        جدول فراوانی حمایت‌ها
                      </h4>
                      <div class="text-sm-left text-center">
                        <v-btn
                          class="bc-primary text-white btn-radius mt-5 mb-10"
                          width="200"
                          height="47"
                          elevation="0"
                          @click="$refs.table1.$el.click()"
                        >
                          <span class="fs-small">
                            خروجی اکسل

                            <v-icon>$Excel</v-icon></span
                          >
                        </v-btn>
                        <vue-excel-xlsx
                          v-show="false"
                          ref="table1"
                          :data="barTable"
                          :columns="excelBarFields"
                          :filename="'جدول-فراوانی-حمایت‌ها '"
                          :sheetname="currentDate"
                        >
                          دریافت اکسل
                        </vue-excel-xlsx>
                      </div>
                      <b-table
                        responsive
                        small
                        show-empty
                        stacked="sm"
                        tbody-tr-class="trClass"
                        thead-class="thClass"
                        empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                        :items="barTable"
                        :fields="barFields"
                        :current-page="barCurrentPage"
                        :per-page="perPage"
                        :filter="filter"
                        :busy="tableBusy"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(mahvars)="data">
                          <div style="vertical-align: middle; max-width: 350px">
                            <ul v-if="data.value != '-'">
                              <li
                                v-for="(item, index) in data.value"
                                :key="index"
                              >
                                {{ item }}
                              </li>
                            </ul>
                            <span v-else>-</span>
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{
                              data.index + perPage * (barCurrentPage - 1) + 1
                            }}
                          </div>
                        </template>
                      </b-table>
                      <v-row v-if="barTotalRows">
                        <v-col>
                          <v-pagination
                            v-model="barCurrentPage"
                            :length="Math.ceil(barTotalRows / perPage)"
                            :total-visible="5"
                            prev-icon="arrow_back"
                            next-icon="arrow_forward"
                            class="float-left"
                          ></v-pagination>
                        </v-col>
                      </v-row>

                      <h4 class="mt-10 text-sm-right text-center">
                        جدول تقسیم بندی نسبی حمایت‌ها
                      </h4>
                      <div class="text-sm-left text-center">
                        <v-btn
                          class="bc-primary text-white btn-radius mt-5 mb-10"
                          width="200"
                          height="47"
                          elevation="0"
                          @click="$refs.table2.$el.click()"
                        >
                          <span class="fs-small">
                            خروجی اکسل

                            <v-icon>$Excel</v-icon></span
                          >
                        </v-btn>
                        <vue-excel-xlsx
                          v-show="false"
                          ref="table2"
                          :data="pieTable"
                          :columns="excelPieFields"
                          :filename="'جدول-تقسیم‌بندی-نسبی-حمایت‌ها '"
                          :sheetname="currentDate"
                        >
                          دریافت اکسل
                        </vue-excel-xlsx>
                      </div>
                      <b-table
                        responsive
                        small
                        show-empty
                        stacked="sm"
                        tbody-tr-class="trClass"
                        thead-class="thClass"
                        empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                        :items="pieTable"
                        :fields="pieFields"
                        :current-page="pieCurrentPage"
                        :per-page="perPage"
                        :filter="filter"
                        :busy="tableBusy"
                        empty-text="رکوردی برای نمایش وجود ندارد"
                        class="table table-secondary"
                      >
                        <template v-slot:head()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.label }}
                          </div>
                        </template>
                        <template v-slot:cell()="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{ data.value }}
                          </div>
                        </template>
                        <template v-slot:cell(mahvars)="data">
                          <div style="vertical-align: middle; max-width: 350px">
                            <ul v-if="data.value != '-'">
                              <li
                                v-for="(item, index) in data.value"
                                :key="index"
                              >
                                {{ item }}
                              </li>
                            </ul>
                            <span v-else>-</span>
                          </div>
                        </template>
                        <template v-slot:cell(index)="data">
                          <div
                            style="text-align: center; vertical-align: middle"
                          >
                            {{
                              data.index + perPage * (pieCurrentPage - 1) + 1
                            }}
                          </div>
                        </template>
                      </b-table>
                      <v-row v-if="pieTotalRows">
                        <v-col>
                          <v-pagination
                            v-model="pieCurrentPage"
                            :length="Math.ceil(pieTotalRows / perPage)"
                            :total-visible="5"
                            prev-icon="arrow_back"
                            next-icon="arrow_forward"
                            class="float-left"
                          ></v-pagination>
                        </v-col>
                      </v-row>
                    </div>
                    <v-row>
                      <v-col md="6" cols="12">
                        <h5
                          class="mt-6 fs-xlarge text-sm-right text-center pt-3"
                        >
                          جدول دانشگاه‌ها
                        </h5>
                      </v-col>
                      <v-col md="6" cols="12">
                        <div class="text-sm-left text-center">
                          <v-btn
                            class="bc-primary text-white btn-radius my-10"
                            width="200"
                            height="47"
                            elevation="0"
                            @click="$refs.table3.$el.click()"
                          >
                            <span class="fs-small">
                              خروجی اکسل
                              <v-icon>$Excel</v-icon></span
                            >
                          </v-btn>
                          <vue-excel-xlsx
                            v-show="false"
                            ref="table3"
                            :data="items1"
                            :columns="excelFields"
                            :filename="'جدول-دانشگاه'"
                            :sheetname="currentDate"
                          >
                            دریافت اکسل
                          </vue-excel-xlsx>
                        </div>
                      </v-col>
                    </v-row>

                    <b-table
                      responsive
                      small
                      show-empty
                      stacked="sm"
                      tbody-tr-class="trClass"
                      thead-class="thClass"
                      empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                      :items="items1"
                      :fields="fields"
                      :current-page="currentPage"
                      :per-page="perPage"
                      :filter="filter"
                      :busy="tableBusy"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(mahvars)="data">
                        <div style="vertical-align: middle; max-width: 350px">
                          <ul v-if="data.value != '-'">
                            <li
                              v-for="(item, index) in data.value"
                              :key="index"
                            >
                              {{ item }}
                            </li>
                          </ul>
                          <span v-else>-</span>
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + perPage * (currentPage - 1) + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <v-row v-if="totalRows">
                      <v-col>
                        <v-pagination
                          v-model="currentPage"
                          :length="Math.ceil(totalRows / perPage)"
                          :total-visible="5"
                          prev-icon="arrow_back"
                          next-icon="arrow_forward"
                          class="float-left"
                        ></v-pagination>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col md="6" cols="12">
                        <h5
                          class="mt-6 fs-xlarge text-sm-right text-center pt-3"
                        >
                          جدول حمایت‌های انجام شده به تفکیک سال
                        </h5>
                      </v-col>
                      <v-col md="6" cols="12">
                        <div class="text-sm-left text-center">
                          <v-btn
                            class="bc-primary text-white btn-radius my-10"
                            width="200"
                            height="47"
                            elevation="0"
                            @click="$refs.table4.$el.click()"
                          >
                            <span class="fs-small">
                              خروجی اکسل

                              <v-icon>$Excel</v-icon></span
                            >
                          </v-btn>
                          <vue-excel-xlsx
                            v-show="false"
                            ref="table4"
                            :data="items2"
                            :columns="excelFields2"
                            :filename="'جدول حمایت‌های انجام شده به تفکیک سال'"
                            :sheetname="currentDate"
                          >
                            دریافت اکسل
                          </vue-excel-xlsx>
                        </div>
                      </v-col>
                    </v-row>

                    <b-table
                      responsive
                      small
                      show-empty
                      stacked="sm"
                      tbody-tr-class="trClass"
                      thead-class="thClass"
                      empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                      :items="items2"
                      :fields="fields2"
                      :current-page="currentPage2"
                      :per-page="perPage"
                      :filter="filter"
                      :busy="tableBusy"
                      empty-text="رکوردی برای نمایش وجود ندارد"
                      class="table table-secondary"
                    >
                      <template v-slot:head()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.label }}
                        </div>
                      </template>
                      <template v-slot:cell()="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.value }}
                        </div>
                      </template>
                      <template v-slot:cell(index)="data">
                        <div style="text-align: center; vertical-align: middle">
                          {{ data.index + perPage * (currentPage2 - 1) + 1 }}
                        </div>
                      </template>
                    </b-table>
                    <v-row v-if="totalRows2">
                      <v-col>
                        <v-pagination
                          v-model="currentPage2"
                          :length="Math.ceil(totalRows2 / perPage2)"
                          :total-visible="5"
                          prev-icon="arrow_back"
                          next-icon="arrow_forward"
                          class="float-left"
                        ></v-pagination>
                      </v-col>
                    </v-row>

                    <div class="mt-12">
                      <v-expansion-panels accordion>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >طرح های پیشنهادی فناورانه حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items1"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items1"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items1 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >طرح های پسادکتری حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items2"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items2"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items2 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >رساله های دکتری حمایت شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items3"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items3"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items3 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >پایان نامه های کارشناسی ارشد حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items4"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items4"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items4 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >فرصت‌های مطالعاتی حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items5"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items5"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items5 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >نشست‌های استانی حمایت شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items6"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items6"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items6 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >مقالات زیست فناوری حمایت
                            شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items7"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items7"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items7 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel @change="projectCurrentPage = 1">
                          <v-expansion-panel-header
                            >نخبگان وظیفه حمایت شده</v-expansion-panel-header
                          >
                          <v-expansion-panel-content>
                            <div class="py-6">
                              <v-row>
                                <v-col>
                                  <b-table
                                    responsive
                                    small
                                    show-empty
                                    stacked="sm"
                                    tbody-tr-class="trClass"
                                    thead-class="thClass"
                                    empty-filtered-text="رکوردی برای نمایش وجود ندارد."
                                    :items="projects.items8"
                                    :fields="projectFields"
                                    :current-page="projectCurrentPage"
                                    :per-page="perPage"
                                    :filter="filter"
                                    :busy="tableBusy"
                                    empty-text="رکوردی برای نمایش وجود ندارد"
                                    class="table table-secondary"
                                  >
                                    <template v-slot:head()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{ data.label }}
                                      </div>
                                    </template>
                                    <template v-slot:cell()="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(progress)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{
                                          data.value != "-"
                                            ? "%" + data.value
                                            : data.value
                                        }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(mehvar)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                          max-width: 350px;
                                        "
                                      >
                                        {{ data.value }}
                                      </div>
                                    </template>
                                    <template v-slot:cell(index)="data">
                                      <div
                                        style="
                                          text-align: center;
                                          vertical-align: middle;
                                        "
                                      >
                                        {{
                                          data.index +
                                          perPage * (projectCurrentPage - 1) +
                                          1
                                        }}
                                      </div>
                                    </template>
                                  </b-table>
                                  <v-row
                                    class="mt-4"
                                    v-if="projectTotalRows.items8"
                                  >
                                    <v-col class="pagination-col">
                                      <v-pagination
                                        v-model="projectCurrentPage"
                                        :length="
                                          Math.ceil(
                                            projectTotalRows.items8 / perPage
                                          )
                                        "
                                        :total-visible="5"
                                        prev-icon="arrow_back"
                                        next-icon="arrow_forward"
                                        class="float-left"
                                      ></v-pagination>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-col>
          </v-row>
          <v-dialog v-model="selectedUniDialog" width="600">
            <v-card class="modal-card">
              <v-container class="pa-5">
                <v-row class="mb-1">
                  <v-col class="text-right">
                    <span class="fs-large c-dark pt-1"
                      >دانشگاه‌های انتخاب شده:</span
                    >
                  </v-col>
                  <v-col class="text-left">
                    <span @click="selectedUniDialog = false">
                      <v-icon class="pointer">$Close</v-icon>
                    </span>
                  </v-col>
                </v-row>
                <div style="max-height: 400px; overflow-y: auto">
                  <div
                    v-for="(item, index) in selectedUniversity"
                    :key="index"
                    class="my-4 fs-medium c-grey d-flex flex-row"
                  >
                    <div class="small-logoBox">
                      <img
                        :src="getLogo(item) ? getLogo(item) : '/uniLogo.png'"
                        alt=""
                      />
                    </div>
                    <div class="pa-4">
                      {{ university.filter((x) => x.id == item)[0].name }}
                    </div>
                  </div>
                </div>
              </v-container>
            </v-card>
          </v-dialog>
        </div>
      </div>

      <v-row v-if="!pageLoading" class="mt-8 w-100">
        <v-col
          class="text-right pe-0 ps-0"
          v-if="stepNumber < 4"
          md="4"
          sm="6"
          cols="12"
        >
          <v-btn
            class="bc-primary text-white no-underline btn-radius w-100 ms-3"
            elevation="0"
            height="43"
            @click="nextStep()"
            :disabled="computedNextButton"
            >گام بعدی</v-btn
          >
        </v-col>
        <v-spacer v-if="stepNumber < 4"></v-spacer>
        <v-col class="text-left pe-0 ps-0" md="4" sm="6" cols="12">
          <v-btn
            class="b-primary bc-white c-primary no-underline btn-radius w-100 ms-3"
            elevation="0"
            height="43"
            @click="previousStep()"
            v-if="stepNumber > 1"
            >گام قبلی</v-btn
          >
        </v-col>
      </v-row>
    </div>
    <div class="goToDown" @click="goDown()">
      <v-icon>mdi-chevron-down</v-icon>
    </div>
    <!-- docx -->
    <div v-show="false" id="doc">
      <div style="direction: rtl">
        <h2 style="text-align: center">گزارش دانشگاه</h2>
        <br />
        <div v-if="barTable.length">
          <h3 class="mt-6">جدول فراوانی حمایت‌ها به تفکیک نوع حمایت</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="barTable"
            :fields="barFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="pieTable.length">
          <h3 class="mt-10">جدول تقسیم بندی نسبی حمایت‌های انجام شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="pieTable"
            :fields="pieFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(mahvars)="data">
              <div style="vertical-align: middle; max-width: 350px">
                <ul v-if="data.value != '-'">
                  <li v-for="(item, index) in data.value" :key="index">
                    {{ item }}
                  </li>
                </ul>
                <span v-else>-</span>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <h3 class="mt-10">جدول دانشگاه‌ها</h3>

        <div v-if="items1.length">
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="items1"
            :fields="fields"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(mahvars)="data">
              <div style="vertical-align: middle; max-width: 350px">
                <ul v-if="data.value != '-'">
                  <li v-for="(item, index) in data.value" :key="index">
                    {{ item }}
                  </li>
                </ul>
                <span v-else>-</span>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <h3 class="mt-10">جدول حمایت‌های انجام شده به تفکیک سال</h3>
        <div v-if="items2.length">
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="items2"
            :fields="fields2"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items1.length">
          <h3 class="mt-10">طرح های پیشنهادی فناورانه حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items1"
            :fields="projectFields"
            :filter="filter"
            head-variant="light"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items2.length">
          <h3 class="mt-10">طرح های پسادکتری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items2"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items3.length">
          <h3 class="mt-10">رساله های دکتری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items3"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items4.length">
          <h3 class="mt-10">پایان نامه‌های کارشناسی ارشد</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items4"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items5.length">
          <h3 class="mt-10">فرصت‌های مطالعاتی حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items5"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items6.length">
          <h3 class="mt-10">نشست‌های استانی حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items6"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items7.length">
          <h3 class="mt-10">مقالات زیست فناوری حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items7"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
        <!-- .................... -->
        <div v-if="projects.items8.length">
          <h3 class="mt-10">نخبگان وظیفه حمایت شده</h3>
          <b-table
            responsive
            small
            show-empty
            stacked="sm"
            tbody-tr-class="trClass"
            thead-class="thClass"
            empty-filtered-text="رکوردی برای نمایش وجود ندارد."
            :items="projects.items8"
            :fields="projectFields"
            :filter="filter"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(progress)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value != "-" ? "%" + data.value : data.value }}
              </div>
            </template>
            <template v-slot:cell(mehvar)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  max-width: 350px;
                "
              >
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.index) + 1 }}
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import moment from "moment-jalaali";
import screenShot from "../../../mixins/screenShot";
import Chart from "../../../components/charts/Chart.vue";
import YearModal from "@/components/YearModal";
//import { set } from "vue/types/umd";
export default {
  components: {
    datePicker: VuePersianDatetimePicker,
    Chart,
    YearModal,
  },
  mixins: [screenShot],
  data() {
    return {
      filter: "",
      vLoading: false,
      iran: [],
      isSelected: false,
      selectedStates: [],
      selectedStatesIds: [],
      selectedUniversity: [],
      total: false,
      total2: false,
      stepNumber: 1,
      university: [],
      noUniversity: false,
      otherUniversity: false,
      projects: {
        items1: [],
        items2: [],
        items3: [],
        items4: [],
        items5: [],
        items6: [],
        items7: [],
        items8: [],
      },
      universitiesCurrentPage: 1,
      universitiesTotalRows: "",
      universitiesPerPage: 16,
      timeType: "",
      selectYearDialog: false,
      selectTimeRangeDialog: false,
      selectedUniDialog: false,
      selectDayModal: false,
      moment: moment,
      currentDate: moment(new Date()).format("jYYYY-jMM-jDD"),
      year: moment(new Date()).format("jYYYY"),
      selectedYear: "",
      currentYear: moment(new Date()).format("jYYYY"),
      range: {
        fromYear: parseInt(moment(new Date()).format("jYYYY")) - 1,
        fromMonth: moment(new Date()).format("jMM"),
        fromDay: moment(new Date()).format("jDD"),
        toYear: moment(new Date()).format("jYYYY"),
        toMonth: moment(new Date()).format("jMM"),
        toDay: moment(new Date()).format("jDD"),
      },
      monthsName: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      barFields: [
        // { key: "index", label: "#" },
        { key: "name", label: "عنوان" },
        { key: "data", label: "تعداد" },
        { key: "data2", label: "تعداد کل" },
      ],
      excelBarFields: [
        // { key: "index", label: "#" },
        { field: "name", label: "عنوان" },
        { field: "data", label: "تعداد" },
        { field: "data2", label: "تعداد کل" },
      ],
      pieFields: [
        // { key: "index", label: "#" },
        { key: "name", label: "عنوان" },
        { key: "data", label: "تعداد" },
      ],
      excelPieFields: [
        // { key: "index", label: "#" },
        { field: "name", label: "عنوان" },
        { field: "data", label: "تعداد" },
      ],
      fields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام دانشگاه" },
        { key: "mahvars", label: "محورهای تقسیم کار ملی دانشگاه" },
        { key: "researchAssistant", label: "معاون پژوهشی" },
        {
          key: "bioScienceCommitteeCounts",
          label: "تعداد اعضای هیئت علمی در حوزه زیست فناوری",
        },
      ],
      excelFields: [
        { field: "name", label: "نام دانشگاه" },
        { field: "mahvars", label: "محورهای تقسیم کار ملی دانشگاه" },
        { field: "researchAssistant", label: "معاون پژوهشی" },
        {
          field: "bioScienceCommitteeCounts",
          label: "تعداد اعضای هیئت علمی در حوزه زیست فناوری",
        },
      ],
      fields2: [
        { key: "year", label: "سال" },
        { key: "project", label: "طرح تحقیقاتی" },
        { key: "opportune", label: "فرصت مطالعاتی" },
        { key: "phd", label: "رساله دکتری" },
        { key: "meeting", label: "نشست تخصصی" },
        { key: "master", label: "پایان نامه ارشد" },
        { key: "postDoc", label: "دوره پسادکتری" },
        { key: "article", label: "مقاله ISI" },
        { key: "elite", label: "نخبه وظیفه" },
      ],
      excelFields2: [
        { field: "year", label: "سال" },
        { field: "project", label: "طرح تحقیقاتی" },
        { field: "opportune", label: "فرصت مطالعاتی" },
        { field: "phd", label: "رساله دکتری" },
        { field: "meeting", label: "نشست تخصصی" },
        { field: "master", label: "پایان نامه ارشد" },
        { field: "postDoc", label: "دوره پسادکتری" },
        { field: "article", label: "مقاله ISI" },
        { field: "elite", label: "نخبه وظیفه" },
      ],
      project1: [],
      projectFields: [
        // { key: "index", label: "#" },
        { key: "faSubject", label: "عنوان طرح" },
        { key: "requestsCode", label: "کد طرح" },
        { key: "startDate", label: "تاریخ شروع" },
        { key: "finalDate", label: "تاریخ پایان" },
        { key: "progress", label: "درصد پیشرفت" },
        { key: "companyName", label: "نام شرکت دانش بنیان" },
        { key: "zones", label: "حوزه فعالیت" },
        { key: "mehvar", label: "محور تقسیم کار ملی" },
        { key: "observer", label: "نام ناظر طرح" },
      ],
      currentPage: 1,
      totalRows: "",
      perPage: 10,
      barCurrentPage: 1,
      barTotalRows: "",
      pieCurrentPage: 1,
      pieTotalRows: "",
      currentPage2: 1,
      projectCurrentPage: 1,
      totalRows2: "",
      projectTotalRows: {
        items1: null,
        items2: null,
        items3: null,
        items4: null,
        items5: null,
        items6: null,
        items7: null,
        items8: null,
      },
      perPage2: 10,
      tableBusy: false,
      items1: [],
      items2: [],
      selectedRange: {},
      fromNumberOfDay: null,
      toNumberOfDay: null,
      dateType: "",
      tab: null,
      barBusy: false,
      doughnutBusy: false,
      barLoaded: false,
      doughnutLoaded: false,
      dataBar: {
        labels: [],
        datasets: [],
      },
      optionsBar1: {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            display: false,
            position: "top",
            align: "start",
            rtl: true,
            labels: {
              font: {
                family: "iransans",
              },
              boxWidth: 24,
              boxHeight: 24,
              usePointStyle: true,
              pointStyle: "circle",
              filter: function (item) {
                // Logic to remove a particular legend item goes here
                return item.text != "";
              },
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },

        title: {
          display: true,
          fontSize: 16,
          position: "top",
          text: "",
        },

        scales: {
          y: {
            scaleLabel: {
              display: true,
              labelString: "",
            },
            ticks: {
              beginAtZero: true,
              font: { family: "iransans" },
            },
          },
          x: {
            ticks: {
              barThickness: 45,
              barPercentage: 1.0,
              categoryPercentage: 0.8,
              font: {
                family: "iransans",
              },
            },
          },
        },
      },
      dataPie: {
        labels: [],
        datasets: [],
      },
      optionsBar2: {
        responsive: true,
        maintainAspectRatio: false,
        cutout: 40,
        plugins: {
          legend: {
            display: false,
            position: "left",
            fontSize: 16,
            rtl: true,
            labels: {
              font: {
                family: "iransans",
                size: 16,
              },
              usePointStyle: true,
              pointStyle: "circle",
            },
          },
          tooltip: {
            titleFont: {
              family: "iransans",
            },
            bodyFont: {
              family: "iransans",
            },
          },
        },
      },
      deviceType: "",
      pageLoading: false,
      reactivity: true,
      allData: {},
      barTable: [],
      pieTable: [],
      showYearModal: false,
      showYearFromModal: false,
      showYearToModal: false,
    };
  },
  methods: {
    getItemYear(value) {
      this.year = value;
      this.selectedYear = this.year;
      this.timeType = "year";
    },
    getShowModal(value) {
      this.showYearModal = value;
    },
    getYearFrom(value) {
      this.range.fromYear = value;
    },
    getYearFromModal(value) {
      this.showYearFromModal = value;
      this.getNumberOfDays("from");
    },
    getYearTo(value) {
      this.range.toYear = value;
    },
    getYearToModal(value) {
      this.showYearToModal = value;
      this.getNumberOfDays("to");
    },
    persianMonthName(month) {
      let monthName;
      monthName = this.monthsName[Number(month) - 1];
      return monthName;
    },
    getLogo(item) {
      if (this.university.filter((x) => x.id == item)) {
        return this.university.filter((x) => x.id == item)[0].url;
      } else return "";
    },
    goDown() {
      var container = document.querySelector("html");
      var scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },
    saveDocx(element) {
      var preHtml =
        "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>sarmad</title><style>.done{color: black} .required{color:red} strong{font-family:B Titr;} table, td, th {border: 1px solid black} table {width:100%; border-collapse: collapse} .all{direction : rtl; text-align: right} body{font-family:B Nazanin;}</style></body></body></head><body>";
      var postHtml = "</body></html>";
      var html =
        preHtml + document.getElementById(element).innerHTML + postHtml;

      var blob = new Blob(["\ufeff", html], {
        type: "application/msword",
      });

      // Specify link url
      var url =
        "data:application/vnd.ms-word;charset=utf-8," +
        encodeURIComponent(html);

      // Specify file name
      let filename = "گزارش-دانشگاه.doc";

      // Create download link element
      var downloadLink = document.createElement("a");

      document.body.appendChild(downloadLink);

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // Create a link to the file
        downloadLink.href = url;

        // Setting the file name
        downloadLink.download = filename;

        //triggering the function
        downloadLink.click();
      }

      document.body.removeChild(downloadLink);
    },
    chooseState(item) {
      if (
        this.selectedStates.length &&
        this.selectedStates.includes(item.name)
      ) {
        let index;
        index = this.selectedStates.indexOf(item.name);
        this.selectedStates.splice(index, 1);
        this.selectedStatesIds.splice(index, 1);
      } else {
        this.selectedStates.push(item.name);
        this.selectedStatesIds.push(item.id);
      }

      if (this.selectedStates.length == this.iran.length) {
        this.total = true;
      } else {
        this.total = false;
      }
    },
    chooseUniversity(item) {
      if (
        this.selectedUniversity.length &&
        this.selectedUniversity.includes(item.id)
      ) {
        let index;
        index = this.selectedUniversity.indexOf(item.id);
        this.selectedUniversity.splice(index, 1);
      } else {
        this.selectedUniversity.push(item.id);
      }

      if (this.selectedUniversity.length == this.university.length) {
        this.total2 = true;
      } else {
        this.total2 = false;
      }
    },
    selectOther() {
      if (this.selectedUniversity.length == this.university.length) {
        if (this.otherUniversity) {
          this.total2 = true;
        } else {
          this.total2 = false;
        }
      } else {
        this.total2 = false;
      }
    },
    selectAll(type) {
      if (type == "state") {
        this.iran.forEach((x) => {
          if (!this.selectedStates.includes(x.name)) {
            this.selectedStates.push(x.name);
            this.selectedStatesIds.push(x.id);
          }
        });
        this.noUniversity = true;
        this.otherUniversity = true;
        this.total = true;
      }
      if (type == "uni") {
        this.university.forEach((x) => {
          if (!this.selectedUniversity.includes(x.id)) {
            this.selectedUniversity.push(x.id);
          }
        });

        this.total2 = true;
      }
      this.goDown();
    },
    removeAll(type) {
      if (type == "state") {
        this.selectedStates = [];
        this.selectedStatesIds = [];
        this.noUniversity = false;
        this.otherUniversity = false;
        this.total = false;
      }
      if (type == "uni") {
        this.selectedUniversity = [];

        this.total2 = false;
      }
    },
    clearItem(index) {
      this.selectedStates.splice(index, 1);
      this.selectedStatesIds.splice(index, 1);
      this.selectedUniversity = [];
      this.noUniversity = false;
      this.otherUniversity = false;
      this.total2 = false;
      if (!this.selectedStates.length) {
        this.previousStep();
        return;
      }

      this.getUniversities();
    },
    nextStep() {
      this.filter = "";
      if (this.stepNumber == 1) {
        if (this.selectedStates.length) {
          ++this.stepNumber;
          this.total2 = false;
          this.selectedUniversity = [];
          this.getUniversities();
        } else {
          this.total2 = false;
          this.selectedUniversity = [];
          this.stepNumber = 3;
        }
      } else {
        ++this.stepNumber;
        if (this.stepNumber == 2) {
          this.total2 = false;
          this.selectedUniversity = [];
          this.getUniversities();
        }
        if (this.stepNumber == 4) {
          this.tab = 0;

          this.getReportInfo();
        }
      }
      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },
    previousStep() {
      this.filter = "";
      if (this.stepNumber == 3 && !this.selectedStates.length) {
        this.stepNumber = 1;
      } else {
        --this.stepNumber;
      }

      setTimeout(() => {
        document.querySelector("html").scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      }, 100);
    },

    getStates() {
      this.pageLoading = true;
      this.$http
        .get(this.baseUrl + "/setad/public/states/list", {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("userId"),
          },
        })
        .then((res) => {
          this.iran = res.data;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    goToSelectRange() {
      this.selectTimeRangeDialog = true;
      this.getNumberOfDays("from");
      this.getNumberOfDays("to");
    },
    changeDate(type) {
      if (type == "year") {
        if (this.range.fromYear > this.range.toYear) {
          this.range.toYear = this.range.fromYear;
        }
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth > this.range.toMonth) {
            this.range.toMonth = this.range.fromMonth;
          }
        }
        if (
          this.range.fromYear == this.range.toYear &&
          this.range.fromMonth == this.range.toMonth
        ) {
          if (this.range.fromDay > this.range.toDay) {
            this.range.toDay = this.range.fromDay;
          }
        }
      }
      if (type == "month") {
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth > this.range.toMonth) {
            this.range.toMonth = this.range.fromMonth;
          }
          if (this.range.fromMonth == this.range.toMonth) {
            if (this.range.fromDay > this.range.toDay) {
              this.range.toDay = this.range.fromDay;
            }
          }
        }
      }
      if (type == "day") {
        if (this.range.fromYear == this.range.toYear) {
          if (this.range.fromMonth == this.range.toMonth) {
            if (this.range.fromDay > this.range.toDay) {
              this.range.toDay = this.range.fromDay;
            }
          }
        }
      }
    },
    getNumberOfDays(type) {
      if (type == "from") {
        if (1 <= parseInt(this.range.fromMonth) < 7) {
          this.fromNumberOfDay = 31;
        }
        if (
          7 <= parseInt(this.range.fromMonth) &&
          parseInt(this.range.fromMonth) != 12
        ) {
          this.fromNumberOfDay = 30;
        }
        if (parseInt(this.range.fromMonth) == 12) {
          let isLead = moment(
            this.range.fromYear + "/12/30",
            "jYYYY/jMM/jDD"
          ).isValid();
          if (isLead) {
            this.fromNumberOfDay = 30;
          } else this.fromNumberOfDay = 29;
        }

        if (parseInt(this.range.fromDay) > parseInt(this.fromNumberOfDay)) {
          this.range.fromDay = this.fromNumberOfDay;
        }
      } else {
        if (1 <= parseInt(this.range.toMonth) < 7) {
          this.toNumberOfDay = 31;
        }
        if (
          7 <= parseInt(this.range.toMonth) &&
          parseInt(this.range.toMonth) != 12
        ) {
          this.toNumberOfDay = 30;
        }
        if (parseInt(this.range.toMonth) == 12) {
          let isLead = moment(
            this.range.toYear + "/12/30",
            "jYYYY/jMM/jDD"
          ).isValid();
          if (isLead) {
            this.toNumberOfDay = 30;
          } else this.toNumberOfDay = 29;
        }

        if (parseInt(this.range.toDay) > parseInt(this.toNumberOfDay)) {
          this.range.toDay = this.toNumberOfDay;
        }
      }
    },
    goFirst() {
      this.universitiesCurrentPage = 1;
    },
    getUniversities() {
      this.pageLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/admin/reports/universities/getBystate",
          {
            states: this.selectedStatesIds,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.university = res.data;
          this.universitiesTotalRows = this.university.length;
          this.pageLoading = false;
        })
        .catch((err) => {
          this.pageLoading = false;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getReportInfo() {
      this.pageLoading = true;
      this.barBusy = true;
      this.doughnutBusy = true;

      this.$http
        .post(
          this.baseUrl + "/setad/admin/reports/universities/getReport",
          {
            universityIds: this.selectedUniversity,
            reportType: this.timeType,
            year: this.timeType == "year" ? this.year : "",
            startDate:
              this.timeType == "time"
                ? this.range.fromYear +
                  "/" +
                  this.range.fromMonth +
                  "/" +
                  this.range.fromDay
                : "",
            endDate:
              this.timeType == "time"
                ? this.range.toYear +
                  "/" +
                  this.range.toMonth +
                  "/" +
                  this.range.toDay
                : "",
            isNot: this.noUniversity,
            isOther: this.otherUniversity,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.allData = res.data;
            // tables
            this.items1 = res.data.universitiesInfo;
            this.totalRows = this.items1.length;
            this.items2 = res.data.yearTable;
            this.totalRows2 = this.items2.length;

            // charts
            this.dataBar = res.data.barChart;
            this.dataBar.datasets[0].barPercentage = 0.8;
            this.dataBar.datasets[0].borderRadius = 5;
            this.dataBar.datasets[1].barPercentage = 0.8;
            this.dataBar.datasets[1].borderRadius = 5;
            this.barBusy = false;
            this.dataPie = res.data.pieChart;
            this.doughnutBusy = false;
            this.projects.items1 = res.data.project;
            this.projects.items2 = res.data.postDoc;
            this.projects.items3 = res.data.phd;
            this.projects.items4 = res.data.master;
            this.projects.items5 = res.data.opportune;
            this.projects.items6 = res.data.meeting;
            this.projects.items7 = res.data.article;
            this.projects.items8 = res.data.elite;
            this.barTable = this.dataBar.labels.map((label, index) => {
              return {
                name: label,
                data: this.dataBar.datasets[0].data[index],
                data2: this.dataBar.datasets[1].data[index],
              };
            });
            this.barTotalRows = this.barTable.length;
            this.pieTable = this.dataPie.labels.map((label, index) => {
              return {
                name: label,
                data: this.dataPie.datasets[0].data[index],
              };
            });
            this.pieTotalRows = this.pieTable.length;
            // total rows
            this.projectTotalRows.items1 = this.projects.items1.length;
            this.projectTotalRows.items2 = this.projects.items2.length;
            this.projectTotalRows.items3 = this.projects.items3.length;
            this.projectTotalRows.items4 = this.projects.items4.length;
            this.projectTotalRows.items5 = this.projects.items5.length;
            this.projectTotalRows.items6 = this.projects.items6.length;
            this.projectTotalRows.items7 = this.projects.items7.length;
            this.projectTotalRows.items8 = this.projects.items8.length;
            if (window.screen.width < 650 || document.body.clientWidth < 650) {
              this.optionsBar1.plugins.legend.labels.font.size = "8";
              this.optionsBar1.scales.x.ticks.font.size = "8";
              this.optionsBar1.scales.y.ticks.font.size = "8";
              this.optionsBar1.plugins.legend.position = "bottom";
            }
            if (window.screen.width < 650 || document.body.clientWidth < 650) {
              this.optionsBar2.plugins.legend.labels.font.size = "10";
              this.optionsBar2.plugins.legend.position = "top";
            }
          }
        });
      setTimeout(() => {
        this.barLoaded = true;
        this.doughnutLoaded = true;
        this.pageLoading = false;
      }, 4000);
    },
  },
  computed: {
    computedStates() {
      if (this.filter) {
        let filtered;
        filtered = this.iran.filter((x) => x.name.includes(this.filter));
        return filtered;
      } else {
        return this.iran;
      }
    },
    computedUniversities() {
      let filtered;
      filtered = this.university.filter((x) => x.name.includes(this.filter));
      filtered = filtered.slice(
        16 * (this.universitiesCurrentPage - 1),
        16 * this.universitiesCurrentPage
      );
      return filtered;
    },
    computedNextButton() {
      if (this.stepNumber == 1) {
        if (
          !this.selectedStates.length &&
          !this.otherUniversity &&
          !this.noUniversity
        ) {
          return true;
        } else return false;
      }
      if (this.stepNumber == 2) {
        if (
          !this.selectedUniversity.length &&
          !this.otherUniversity &&
          !this.noUniversity
        ) {
          return true;
        } else return false;
      }
      if (this.stepNumber == 3) {
        if (!this.timeType) {
          return true;
        } else return false;
      }
    },
    computedCharts() {
      if (!this.allData.barChartHasData && !this.allData.pieChartHasData) {
        return true;
      } else return false;
    },
  },
  mounted() {
    if (window.screen.width < 500) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 500) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    this.gettingPic = [false, false];
    this.getStates();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  .edit-icon {
    path {
      stroke: #068d9d !important;
    }
    transform: translateY(-2px);
  }
  .v-card__title {
    border-radius: 10px 10px 0 0;
  }
  .day-box {
    width: 37px;
    height: 37px;
    text-align: center;
    border-radius: 50%;
    padding-top: 8px;
    color: #656a81;
    &:hover {
      background-color: #eeeeee;
    }
    &.selected {
      background-color: #e6e6e6;
      color: #068d9d;
      font-weight: bold;
    }
  }
  .small-logoBox {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.universities-page {
  min-height: 400px;
  padding: 15px;
}
</style>
